<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
               <span class="g-text-yellow">Liste des tâches</span>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <div class="row no-gutters">
                    <div class="col-12 col-md-3 container" style="height: 65vh; overflow-y: scroll; ">
                        <div class="mb-1" *ngFor="let d of datas" >
                            <app-course-item></app-course-item>
                        </div>
                    </div>
                    <div class="col-12 col-md-5" style="height: 65vh; overflow-y: scroll; ">
                      <div class="container g-bg-gray rounded py-2 mb-1" *ngFor="let d of datas">
                        <div class="d-flex justify-content-between" >
                            <h6><strong>Apprendre la mutiplication</strong></h6>
                            <span>20/12/2023</span>
                        </div>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        </p>
                      </div>
                    </div>
                    <div class="col-12 col-md-4" style="height: 65vh; overflow-y: scroll; ">
                        <h6>Travail à faire</h6>
                        <div class="mb-1" *ngFor="let d of datas" >
                            <app-time-table-item [myColor1]="'rgba(193, 79, 68, .3)'" [myColor2]="'rgba(193, 79, 68, .7)'"></app-time-table-item>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</div>